import { render } from "./DownHint.vue?vue&type=template&id=20193e38&scoped=true"
import script from "./DownHint.vue?vue&type=script&lang=js"
export * from "./DownHint.vue?vue&type=script&lang=js"

import "./DownHint.vue?vue&type=style&index=0&id=20193e38&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-20193e38"

export default script